(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wetome-kontakt"] && !Shopify.designMode) return;
  try {
    
  // Beim Rückruf ist die Telefonnummer Pflicht und die Nachricht freiwillig, beim Schreiben umgekehrt
  document.addEventListener('change', (ereignis) => {
    const wahl = ereignis.target;
    if (!(wahl instanceof HTMLInputElement) || !wahl.dataset.weg || !wahl.form) return;
    const rueckruf = wahl.form.querySelector('[data-weg="rueckruf"]')?.checked === true;
    const telefon = wahl.form.querySelector('[data-telefon]');
    const nachricht = wahl.form.querySelector('[data-nachricht]');
    if (telefon) telefon.required = rueckruf;
    if (nachricht) nachricht.required = !rueckruf;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wetome-themen"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const einrichten = (bereich) => {
      const chips = bereich.querySelectorAll('.we-themen__chip');
      const karten = bereich.querySelectorAll('.we-themen__karte[data-schlagwoerter]');
      const leer = bereich.querySelector('.we-themen__leer');
      chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
          const alle = chip.hasAttribute('data-alle');
          const begriffe = chip.dataset.begriffe
            .split(',')
            .map((b) => b.trim())
            .filter(Boolean);
          const produkte = chip.dataset.produkte || '';
          let sichtbar = 0;
          karten.forEach((karte) => {
            const passt =
              alle ||
              begriffe.some((b) => karte.dataset.schlagwoerter.includes(b)) ||
              produkte.includes(`|${karte.dataset.produkt}|`);
            karte.hidden = !passt;
            if (passt) sichtbar += 1;
          });
          if (leer) leer.hidden = sichtbar > 0;
        });
      });
    };
    document.querySelectorAll('[data-we-themen]').forEach(einrichten);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-we-themen]').forEach(einrichten);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
